// Analytics helper functions for GA4, GTM, and Meta Pixel

const GA4_ID = process.env.REACT_APP_GA4_ID;
const GTM_ID = process.env.REACT_APP_GTM_ID;
const META_PIXEL_ID = process.env.REACT_APP_META_PIXEL_ID;

// Track custom events
export const trackEvent = (eventName, eventParams = {}) => {
  // Google Analytics 4
  if (window.gtag && GA4_ID) {
    window.gtag('event', eventName, eventParams);
  }

  // Google Tag Manager
  if (window.dataLayer) {
    window.dataLayer.push({
      event: eventName,
      ...eventParams
    });
  }

  // Meta Pixel
  if (window.fbq && META_PIXEL_ID) {
    window.fbq('trackCustom', eventName, eventParams);
  }

  console.log('Event tracked:', eventName, eventParams);
};

// Track button clicks
export const trackButtonClick = (buttonName, location) => {
  trackEvent('button_click', {
    button_name: buttonName,
    location: location
  });
};

// Track form submissions
export const trackFormSubmit = (formName, formData = {}) => {
  trackEvent('form_submit', {
    form_name: formName,
    ...formData
  });
};

// Track carousel/slider interactions
export const trackSlideChange = (sliderName, slideIndex) => {
  trackEvent('slide_change', {
    slider_name: sliderName,
    slide_index: slideIndex
  });
};

// Track scroll depth
let scrollDepthTracked = {};

export const trackScrollDepth = (depth) => {
  if (!scrollDepthTracked[depth]) {
    trackEvent('scroll_depth', {
      depth_percentage: depth
    });
    scrollDepthTracked[depth] = true;
  }
};

// Initialize scroll tracking
export const initScrollTracking = () => {
  let ticking = false;

  const handleScroll = () => {
    if (!ticking) {
      window.requestAnimationFrame(() => {
        const windowHeight = window.innerHeight;
        const documentHeight = document.documentElement.scrollHeight;
        const scrollTop = window.scrollY || document.documentElement.scrollTop;
        const scrollPercentage = Math.round((scrollTop / (documentHeight - windowHeight)) * 100);

        if (scrollPercentage >= 25 && !scrollDepthTracked[25]) {
          trackScrollDepth(25);
        }
        if (scrollPercentage >= 50 && !scrollDepthTracked[50]) {
          trackScrollDepth(50);
        }
        if (scrollPercentage >= 75 && !scrollDepthTracked[75]) {
          trackScrollDepth(75);
        }
        if (scrollPercentage >= 90 && !scrollDepthTracked[90]) {
          trackScrollDepth(90);
        }

        ticking = false;
      });
      ticking = true;
    }
  };

  window.addEventListener('scroll', handleScroll, { passive: true });

  return () => window.removeEventListener('scroll', handleScroll);
};

// Track page views
export const trackPageView = (pagePath, pageTitle) => {
  // GA4
  if (window.gtag && GA4_ID) {
    window.gtag('config', GA4_ID, {
      page_path: pagePath,
      page_title: pageTitle
    });
  }

  // GTM
  if (window.dataLayer) {
    window.dataLayer.push({
      event: 'page_view',
      page_path: pagePath,
      page_title: pageTitle
    });
  }

  // Meta Pixel
  if (window.fbq && META_PIXEL_ID) {
    window.fbq('track', 'PageView');
  }
};

// CTA click tracking
export const trackCTA = (ctaText, ctaLocation) => {
  trackEvent('cta_click', {
    cta_text: ctaText,
    cta_location: ctaLocation
  });
};

// Initialize analytics scripts
export const initAnalytics = () => {
  // This is called from public/index.html
  console.log('Analytics initialized');
};